const Counter = ({ count, add, remove }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <button
        style={{ border: "none", backgroundColor: "white", fontSize: "20px" }}
        onClick={remove}
      >
        -
      </button>
      <h5
        style={{
          border: "1px solid gray",
          padding: "2px",
          width: "20px",
          height: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {count}
      </h5>
      <button
        style={{ border: "none", backgroundColor: "white", fontSize: "20px" }}
        onClick={add}
      >
        +
      </button>
    </div>
  );
};
export default Counter;
